import React from "react";
import { ReactComponent as planet } from "@/assets/icons/logo_planet.svg";
import { ReactComponent as logoText } from "@/assets/icons/logo_text.svg";
import Icon from "../Icon";
import { ChakraProps, Flex, Spacer } from "@chakra-ui/react";

interface LogoProps {
  vertical?: boolean;
  css?: ChakraProps["css"];
  size?: number;
  iconW?: number;
  iconH?: number;
  onClick?(): void;
}

const originLogoSize = 50;
export default function Logo({
  vertical = false,
  css = {},
  size = originLogoSize,
  iconW,
  iconH,
  onClick = () => null,
}: LogoProps) {
  const scaleW = (iconW ?? size) / originLogoSize;
  const scaleH = (iconH ?? size) / originLogoSize;
  return (
    <Flex align="center" flexDir={vertical ? "column" : "row"} css={css} onClick={onClick}>
      <Icon
        style={{
          width: iconW ?? size,
          height: iconH ?? size,
          padding: "5px",
          borderRadius: `${scaleH * 16}px`,
          background: "black",
        }}
        svg={planet}
      />
      <Spacer />
      <Icon
        style={{
          width: 120 * scaleW,
          height: 38 * scaleH,
          fill: "black",
        }}
        svg={logoText}
      />
    </Flex>
  );
}
